export const PlayIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4875_145270)">
        <path d="M7.33337 4.5835V17.4168L17.4167 11.0002L7.33337 4.5835Z" fill="#40608F" />
      </g>
    </svg>
  );
};
